import * as THREE from "three";
import { CSS2DRenderer, CSS2DObject } from "three/addons/renderers/CSS2DRenderer.js";

export function makeCSS2Dannotaition(object, onEnter = () => {}) {
    if (!object || typeof object != "object" || !object.isObject3D) return;

    const isObjectTable = !!object.userData?.loadData;

    const input = document.createElement("input");
    input.type = "number";
    input.style.position = "absolute";
    input.style.bottom = "0";
    input.style.left = "50%";
    input.style.transform = "translateX(-50%)";
    input.style.textAlign = "center";

    let lineText = document.createElement("div");
    lineText.dataset.text = object.name;

    lineText.classList.add("line_text");
    lineText.style.position = "absolute";
    lineText.style.bottom = "0";
    lineText.style.left = "50%";
    lineText.style.transform = "translateX(-50%)";
    lineText.style.fontSize = "30rem";

    input.addEventListener("keydown", (e) => {
        if (e.code == "Enter" || e.code == "NumpadEnter") {
            onEnter(object, e.target.value);
            servObj.building.checkCollision();
        }
        e.stopPropagation();
    });

    let pointHTML = document.createElement("div");
    pointHTML.id = `ann_${object.name || object.id}`;
    pointHTML.classList.add("ann_point");

    !isObjectTable && pointHTML.append(input);

    let point2D = new CSS2DObject(pointHTML);

    point2D.name = "css2d_" + object.name || "id_" + object.id;

    if (isObjectTable) {
        const box = new THREE.Box3().setFromObject(object);

        const center = new THREE.Vector3();
        box.getCenter(center);

        const size = new THREE.Vector3();
        box.getSize(size);

        object.worldToLocal(center);

        // смещение "вперед" по локальной оси Z
        center.z += size.z / 2;

        point2D.position.copy(center);

        document.getElementById("ann_table")?.remove();
        pointHTML.id = `ann_table`;

        point2D.name = "css2d__" + object.name + "__ann_table";
    }

    object.add(point2D);

    servObj.annotations ||= [];
    servObj.annotations.push(point2D);

    return point2D;
}

export function initCSS2DRenderer(container) {
    let labelRenderer = new CSS2DRenderer();
    labelRenderer.setSize(container.innerWidth, container.innerHeight);
    labelRenderer.domElement.style.position = "absolute";
    labelRenderer.domElement.style.top = "0px";
    labelRenderer.domElement.style.pointerEvents = "none";
    labelRenderer.domElement.classList.add("wrap_annotations");
    document.body.appendChild(labelRenderer.domElement);
    return labelRenderer;
}

let raycaster = new THREE.Raycaster();
let v3_1 = new THREE.Vector3();
let v3_2 = new THREE.Vector3();
let v3_3 = new THREE.Vector3();

export function hideInvisibleAnns(camera, annotaitions) {
    if (!camera.isCamera || !annotaitions.length || !servObj.toDecomp || !servObj.showAllAnns) return;

    annotaitions.forEach((ann) => {
        getWorldPositionNorm(camera, v3_1);
        getWorldPositionNorm(ann, v3_2);
        v3_3.copy(v3_2).sub(v3_1).normalize();
        raycaster.set(v3_1, v3_3);
        raycaster.far = v3_1.distanceTo(v3_2);
        let i = raycaster.intersectObject(servObj.app.scene.children[0], !0);
        // let i = raycaster.intersectObject(findRootObj(ann), !0);
        ann.element.style.display = i.length > 1 || (1 == i.length && i[0].object != ann.parent) ? "none" : "block";
        ann.element
            .querySelectorAll(".ann_point_label, .line_1, .line_2, .line_text")
            .forEach((el) =>
                el.classList[i.length > 1 || (1 == i.length && i[0].object != ann.parent) ? "remove" : "add"](
                    "visible",
                    "line_visible",
                ),
            );
    });
}

function getWorldPositionNorm(obj, v3 = new THREE.Vector3()) {
    if (!obj) return;
    return v3.setFromMatrixPosition(obj.matrixWorld);
}
function findRootObj(obj) {
    let e = obj;
    return (
        obj.traverseAncestors(function (t) {
            e = t;
        }),
        e
    );
}
